import { httpRequest } from 'http'
import { updatePlayersMatching } from './players_matching'

export const CLAN_UNITS_REQUEST = 'clan_units/REQUEST'
export const CLAN_UNITS_SUCCESS = 'clan_units/SUCCESS'
export const CLAN_UNITS_SELECT_UNIT = 'clan_units/SELECT'
export const UNIT_STATE_REACTIVE_UPDATE = 'UNIT_STATE_REACTIVE_UPDATE'

export function requestSuccess(response) {
    return dispatch => {
        const playersMatchingSection = response.account_info.players_matching
        if (playersMatchingSection && playersMatchingSection.sortie_settings.length) {
            dispatch(updatePlayersMatching(playersMatchingSection))
        }

        dispatch({
            type: CLAN_UNITS_SUCCESS,
            payload: {
                units: response.data,
                meta: response.meta,
            },
        })
    }
}

function requestStart(showLoader) {
    return {
        type: CLAN_UNITS_REQUEST,
        payload: { showLoader },
    }
}

export const selectUnit = (unit = null) => {
    const unitId = unit ? unit.id : null

    return {
        type: CLAN_UNITS_SELECT_UNIT,
        payload: {
            unitId,
        },
    }
}

export function requestClanUnits(showLoader = false) {
    return async (dispatch) => {
        dispatch(requestStart(showLoader))

        const response = await httpRequest('/game_api/available_units?own_units=true')

        dispatch(requestSuccess(response))
    }
}



// WEBPACK FOOTER //
// ./state/actions/clan_units.js